import { render, staticRenderFns } from "./TreeView2.vue?vue&type=template&id=523ba38c"
import script from "./TreeView2.vue?vue&type=script&lang=js"
export * from "./TreeView2.vue?vue&type=script&lang=js"
import style0 from "./TreeView2.vue?vue&type=style&index=0&id=523ba38c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports